import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_33fe3333-b663-46d5-9a5a-213e797d3d01/artifacts/l3uhj6bk_logo-primary-2026-03-18.png';

export default function Footer() {
  const { t } = useLanguage();

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="bg-[#333F48] text-white py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="AFRICAINOX"
              className="h-8 w-auto mb-6 brightness-0 invert"
              data-testid="footer-logo"
            />
            <p
              className="text-sm text-white/50 leading-relaxed"
              style={{ fontFamily: 'Roboto, sans-serif' }}
            >
              {t('footer.tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-3">
              {['about', 'services', 'process', 'gallery'].map(key => (
                <li key={key}>
                  <button
                    onClick={() => scrollTo(`#${key}`)}
                    data-testid={`footer-link-${key}`}
                    className="text-sm text-white/60 hover:text-white transition-colors duration-200"
                    style={{ fontFamily: 'Roboto, sans-serif' }}
                  >
                    {t(`nav.${key}`)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Sectors */}
          <div>
            <h4
              className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t('footer.sectors')}
            </h4>
            <ul className="space-y-3">
              {['mining', 'horeca', 'healthcare', 'construction'].map(key => (
                <li key={key}>
                  <span
                    className="text-sm text-white/60"
                    style={{ fontFamily: 'Roboto, sans-serif' }}
                  >
                    {t(`services.${key}.title`)}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              {t('footer.contactInfo')}
            </h4>
            <div className="space-y-3">
              <p className="text-sm text-white/60" style={{ fontFamily: 'Roboto, sans-serif' }}>
                Lubumbashi, D.R. Congo
              </p>
              <p className="text-sm text-white/60" style={{ fontFamily: 'Roboto, sans-serif' }}>
                www.africainox.com
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30" style={{ fontFamily: 'Roboto, sans-serif' }}>
            &copy; {new Date().getFullYear()} AFRICAINOX. {t('footer.rights')}
          </p>
          <p className="text-xs text-white/20" style={{ fontFamily: 'Roboto, sans-serif' }}>
            Built in Africa. Engineered to European standards.
          </p>
        </div>
      </div>
    </footer>
  );
}
